import { createListFilters, IOption } from 'app/components'

export type UsuariosFilters = {
  /** Nome do usuário (busca parcial). */
  nome: string
  situacao?: IOption<boolean>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<UsuariosFilters>({
  nome: '',
  situacao: undefined,
})
